import type { MarketplaceEntry } from "../types/index";

interface Props {
  plugin: MarketplaceEntry;
}

export default function InstallInClaude({ plugin }: Props) {
  const hasConnectors = (plugin.mcpServers?.length ?? 0) > 0;

  // The CAI marketplace is pre-installed org-wide via Claude's enterprise admin
  // tooling, so there's no "add the marketplace" step — plug-ins appear directly
  // under the org's tab in the Plugins Directory. Standalone skills (unpacked
  // from a plugin) are NOT published to that directory, so the only way to use
  // one in Chat/Cowork is to download it and add it manually (the detail page
  // renders that download section separately). extensionType may be absent on
  // legacy records; the strict === "skill" check treats anything else (including
  // undefined) as a plug-in.
  const isSkill = plugin.extensionType === "skill";
  const noun = isSkill ? "skill" : "plug-in";

  return (
    <div style={{ marginBottom: "1.25rem", border: "1px solid #d1d5db", borderRadius: "8px", padding: "0.85rem 1rem", backgroundColor: "#fff" }}>
      <div style={{ fontSize: "0.95rem", fontWeight: 700, color: "#111", marginBottom: "0.5rem" }}>
        Install in Claude (Chat &amp; Cowork)
      </div>

      {isSkill ? (
        <div style={{ fontSize: "0.85rem", lineHeight: "1.6", color: "#333" }}>
          <strong>{plugin.pluginName}</strong> is an individual skill, not a plug-in, so it isn&rsquo;t
          listed in the Plugins Directory in Claude Desktop. To use it in Chat or Cowork, download it below and add it
          manually.
        </div>
      ) : (
        <>
          <ol style={{ margin: "0.1rem 0 0", paddingLeft: "1.25rem", fontSize: "0.85rem", lineHeight: "1.6", color: "#333" }}>
            <li>In Claude, go to <strong>Customize → Browse Plugins → Plugins Directory → Your Organization</strong></li>
            <li>Search for <strong>{plugin.pluginName}</strong></li>
            <li>Click <strong>+</strong> to install it — the plug-in is available in your next conversation.</li>
          </ol>
        </>
      )}

      {hasConnectors && (
        <div
          role="note"
          style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem", marginTop: "0.75rem", backgroundColor: "#fffbeb", border: "1px solid #fde68a", borderRadius: "8px", padding: "0.6rem 0.75rem", fontSize: "0.8rem", lineHeight: "1.5", color: "#92400e" }}
        >
          <svg aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: "0.1rem" }}>
            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span>
            This {noun} bundles an MCP connector. In Chat and Cowork, connectors route through
            Anthropic&rsquo;s cloud, so one targeting an internal-only server won&rsquo;t reach it there —
            even though the {noun} installs. It works in Claude Code, which runs locally.
          </span>
        </div>
      )}
    </div>
  );
}
